module.exports = __webpack_public_path__ + "static/media/money-check-edit.5e6ee0b9.svg";